<template>
  <div>
    <label
      :for="id"
      class="input__label"
    >
      {{ translate(label) }} <span v-if="block.is_required">*</span>
    </label>

    <input-select-currency
      class="margin__t--6"
      v-model="currency"
      :id="id"
      :v="validator"
    />
  </div>
</template>

<script setup>
import { inject, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useCurrencyStore } from '@/stores/CurrencyStore'
import { useModule } from '@/composables/app/useModule'
import { useProcedureBlockValidator } from '@/composables/modules/procedures'
import { useI18n } from '@/vendors/i18n'

import InputSelectCurrency from '&/atoms/InputSelectCurrency'

const { block } = defineProps({ block: { type: Object, required: true } })

const procedure_execution = inject('procedure_execution')

const { translate } = useI18n()
const { currency } = storeToRefs(useCurrencyStore())
const { id, label, model } = useModule({ component: block, parent: procedure_execution })
const { validator } = useProcedureBlockValidator({ validations: block.validations, state: model })

watch(currency, () => model.value = currency.value, { immediate: true })
</script>
